// @flow
import * as React from 'react';

import AdminUploadedFileDetail from './AdminUploadedFileDetail';
import Dialog from 'components/Dialog';

type Props = {
  fileUpload: *,
  onClose: () => void,
};

class AdminUploadedFileDetailModal extends React.PureComponent<Props, *> {
  render() {
    return (
      <Dialog size="medium" onRequestHide={this.props.onClose}>
        <AdminUploadedFileDetail fileUpload={this.props.fileUpload} />
      </Dialog>
    );
  }
}

export default AdminUploadedFileDetailModal;
